// extracted by mini-css-extract-plugin
export default {"page":"main-page_page__WKz4C","content":"main-page_content__Tbwzy"};